// 'stringTipoCamelCase' => 'string-tipo-camel-case'

export function dashCase(str) {
  if (typeof str !== 'string') {
    throw new Error(`dashCase: el argumento no es de tipo string, es de tipo "${typeof str}"`);
  }
  if (str === '') {
    return '';
  }

  // forzamos primera letra en minuscula
  str = str[0].toLowerCase() + str.slice(1);

  // reemplazamos las mayusculas por "-"
  return str.replace(/([A-Z])/g, letter => `-${letter[0]}`).toLowerCase();
}
